// @ts-nocheck

import * as Types from '../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetUseNotificationsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.PageModelInput>;
}>;

export type GetUseNotificationsQuery = {
  notifications: { totalCount?: number | null; notifications?: Array<NotificationFragment | null> | null };
};

export type NotificationFragment = {
  uid: string;
  created?: string | null;
  statusModified?: string | null;
  type?: Types.NotificationTypeModel | null;
  status?: Types.NotificationStatusModel | null;
  resourceUid?: string | null;
  resourceLocation?: string | null;
  read?: boolean | null;
  metadata?: Array<{ key?: string | null; value?: string | null } | null> | null;
};

export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationModel {
  uid
  created
  statusModified
  type
  status
  resourceUid
  resourceLocation
  read
  metadata {
    key
    value
  }
}
    ` as unknown as DocumentNode<NotificationFragment, unknown>;
export const GetUseNotificationsDocument = gql`
    query GetUseNotifications($page: PageModelInput) {
  notifications(page: $page) {
    totalCount
    notifications {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}` as unknown as DocumentNode<GetUseNotificationsQuery, GetUseNotificationsQueryVariables>;
